module.exports = __webpack_public_path__ + "media/images/bars-53f590c7528762aaa733e6cc41103afe.svg";